import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Container } from 'react-bootstrap';
import Loader from '../../components/Loader/Loader';
import { getPolicy } from '../../apiservices/ApiServices';
import PageTitle from '../../components/PageTitle/PageTitle';
import { ToastContainer, toast } from 'react-toastify';

const Policy = () => {
    const location = useLocation();
    const subPath = location.pathname.split('/');
    const slug = subPath[subPath.length - 1];

    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    const getPolicys = async (slug) => {
        setLoading(true);
        try {
            const res = await getPolicy(slug);
            setData(res.data.data.length > 0 ? res.data.data[0] : null);
        } catch (error) {
            setData(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getPolicys(slug);
    }, [slug]);

    return (
        <>
            <Header toast={toast} />
            <ToastContainer />
            <section id='content'>
                <div className='content-block'>
                    {isLoading ? (
                        <Loader />
                    ) : data ? (
                        <Container>
                            <div className='titles'>
                                <h1>{data.title}</h1>
                            </div>
                            <div className='content-box' dangerouslySetInnerHTML={{ __html: data.description }}></div>
                        </Container>
                    ) : (
                        <Container>
                            <div className='nodata'>
                                <h2>No data found</h2>
                                <div className='buttonbox'>
                                    <Link className='btn btn-green' to={'/'}>Back to Home</Link>
                                </div>
                            </div>
                        </Container>
                    )}
                </div>
            </section >
            <Footer toast={toast} />
        </>
    );
};

export default Policy;
